import React from "react";

const ProgressBar = ({ survey, progress }) => {
    if (!survey?.showProgressbar) return null;

    if (survey.progressbarType === "STEPS") {
        return (
            <div className="progress mb-4" style={{ height: "25px" }}>
                <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                        width: `${(progress.current / progress.total) * 100}%`,
                    }}
                >
                    Question {progress.current} of {progress.total}
                </div>
            </div>
        );
    }

    return (
        <div className="progress mb-4" style={{ height: "25px" }}>
            <div
                className="progress-bar"
                role="progressbar"
                style={{ width: `${progress}%`, padding: "5px" }}
            >
                {progress}% Complete
            </div>
        </div>
    );
};

export default ProgressBar;
